import { render, staticRenderFns } from "./roundet_small.vue?vue&type=template&id=42d391ec&scoped=true&"
import script from "./roundet_small.vue?vue&type=script&lang=js&"
export * from "./roundet_small.vue?vue&type=script&lang=js&"
import style0 from "./roundet_small.vue?vue&type=style&index=0&id=42d391ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d391ec",
  null
  
)

export default component.exports